<template>
  <div v-if="!lessonEdit" class="lesson_item" :stageId="element.id">
    <div class="before" v-if="!courseInfo.status"></div>
    <div class="parts">
      <div class="part-left">
        <div class="lesson_number">№ {{ index + 1 }}</div>
        <div class="lesson_type">
          <span class="left">Тип урока: </span>
          <span class="right">{{ lessonType(element) }}</span>
        </div>
        <div class="lesson_author" v-if="userRole === 'admin'">
          <router-link :to="'/all-users/' + element.user_id">
            <span class="right blue">Автор: {{ authorName }}</span>
          </router-link>
        </div>
        <div class="lesson_date">
          <span class="left">Дата создания: </span>
          <span class="right">{{ element.created_at | moment('DD.MM.YYYY') }}</span>
        </div>
        <div class="lesson_name">
          <span class="left">Название урока: </span>
          <span class="right">{{ element.name }}</span>
        </div>
      </div>
      <div class="part-right">
        <div class="row">
          <router-link class="add_button" :to="'/all-courses/content/' + element.id + '?courseId=' + this.courseId">
            <i class="mdi mdi-file-document-box-plus-outline"></i> {{ item.text }}
          </router-link>
        </div>
        <div class="row">
          <button class="edit_button" @click="lessonEdit = !lessonEdit">
            <i class="mdi mdi-file-document-edit-outline"></i> Редактировать поля
          </button>
        </div>
        <div class="row">
          <button class="delete_button" @click="$emit('delete', element)">
            <i class="mdi mdi-file-document-box-remove-outline"></i> Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="plan_filter">
    <form @submit.prevent="changeLesson" class="row">
      <b-field label="Укажите тип урока:" type="is-info" class="type_select">
        <b-select v-model="newStage.type" placeholder="Тип урока" required>
          <option :value="0">Тип урока</option>
          <option :value="1">Урок</option>
          <option :value="2">Обучающий тест</option>
          <option :value="3">Итоговый тест</option>
        </b-select>
      </b-field>
      <b-field
        label="Напишите название урока:"
        class="lesson_name"
        type="is-info"
        :message="errors.first('name')"
        :class="errors.first('name') ? 'error' : ''"
      >
        <b-input
          name="name"
          type="text"
          v-model="newStage.name"
          placeholder="Название урока"
          v-validate="{ required: true }"
        ></b-input>
      </b-field>
      <div class="buttons_block">
        <button type="button" class="discard_plan" @click="discardChanges">Отмена</button>
        <button type="submit" class="add_plan" :disabled="errors.items.length > 0">Сохранить</button>
      </div>
    </form>
  </div>
</template>

<script>
import { toastInfo } from '@/lib/toastCfg'

export default {
  props: {
    authorsList: {
      default: () => [],
      type: Array
    },
    element: {
      default: () => {},
      type: Object
    },
    item: {
      default: () => {},
      type: Object
    },
    index: {
      default: () => 0,
      type: Number
    },
    courseInfo: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      lessonEdit: false,
      newStage: {
        type: this.element.type,
        name: this.element.name
      },
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено'
          }
        }
      }
    }
  },
  computed: {
    courseId() {
      return Number(this.$route.params.id)
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    authorName() {
      let user = this.authorsList.find((el) => el.stageIds.some((stage) => Number(stage) === Number(this.element.id)))
      if (user) return user.name
      return ''
    }
  },
  methods: {
    loadStages() {
      this.$axios2
        .get('courses/' + this.courseId + '/stages')
        .then((resp) => {
          this.$store.commit('setStagesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    changeLesson() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        let request = {
          name: this.newStage.name,
          type: this.newStage.type,
          sort_number: this.element.sort_number
        }
        this.$axios2
          .post('courses/' + this.courseId + '/stages/' + this.element.id, request)
          .then(() => {
            this.$buefy.toast.open(toastInfo())
            this.lessonEdit = !this.lessonEdit
            this.loadStages()
          })
          .catch(this.$errorToast)
      })
    },
    discardChanges() {
      this.lessonEdit = !this.lessonEdit
      this.newStage = {
        type: this.element.type,
        name: this.element.name
      }
    },
    lessonType(e) {
      switch (e.type) {
        case 1:
          return 'Урок'
        case 2:
          return 'Обучающий тест'
        case 3:
          return 'Итоговый тест'
      }
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
